import './App.css'
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import AppRoutes from "./routes";

function App() {
    // This is the main App component that renders the application routes.
    return (
        <AppRoutes />
    );
}

export default App;